import { render, staticRenderFns } from "./WxWarehouseSelect.vue?vue&type=template&id=08277b3d&scoped=true&"
import script from "./WxWarehouseSelect.vue?vue&type=script&lang=js&"
export * from "./WxWarehouseSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08277b3d",
  null
  
)

export default component.exports